import { Card, CardContent } from '../ui/card/card';
import { Stack } from '@folio/components/ui/flex';

interface FunnelWithHelperProps {
  helper?: React.ReactNode;
  children: React.ReactNode;
}

export function FunnelWithHelper({ helper, children }: FunnelWithHelperProps) {
  if (!helper) return <>{children}</>;
  return (
    <Stack className="xl:flex-row">
      <Stack className="w-full xl:w-5/7">{children}</Stack>
      <div className="w-full xl:w-2/7">
        <Card className="sticky top-4">
          <CardContent className="pt-6">{helper}</CardContent>
        </Card>
      </div>
    </Stack>
  );
}
